import React from "react";
import { TablePagination } from "@mui/material";
import { PaginationData } from "../types/orderTypes";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

interface OrderPaginationProps {
  paginationData: PaginationData;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
}

const OrderPagination: React.FC<OrderPaginationProps> = ({ paginationData, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    onRowsPerPageChange(newRowsPerPage);
  };

  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
      count={paginationData.totalRecords}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};

export default OrderPagination;
